// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__jYNs1"};